import React from "react";
import "./LogStatusTag.css";

interface LogStatusTagProps {
  status: string;
}

const normalizeStatus = (status: string): string =>
  (status ?? "").trim().toUpperCase();

export const getLogStatusLabel = (status: string): string => {
  const key = normalizeStatus(status);
  if (key === "SUCCESSFUL" || key === "SUCCESS") return "Exitoso";
  if (key === "OK") return "Correcto";
  if (key === "FAILED" || key === "FAIL" || key === "ERROR") return "Fallido";
  return status || "—";
};

const getLogStatusTone = (
  status: string
): "success" | "error" | "default" => {
  const key = normalizeStatus(status);
  if (
    key === "SUCCESSFUL" ||
    key === "SUCCESS" ||
    key === "OK"
  ) {
    return "success";
  }
  if (key === "FAILED" || key === "FAIL" || key === "ERROR") return "error";
  return "default";
};

/**
 * Execution status chip for parent logs (look) and detail rows.
 */
const LogStatusTag: React.FC<LogStatusTagProps> = ({ status }) => {
  const tone = getLogStatusTone(status);
  return (
    <span className={`log-status-tag log-status-tag--${tone}`}>
      {getLogStatusLabel(status)}
    </span>
  );
};

export default LogStatusTag;
